export interface CodedEntry {
  designator: string;
  value: string;
  meaning: string;
}

export const bodyParts: CodedEntry[] = [
  {
    designator: 'SCT',
    meaning: 'Head',
    value: '69536005',
  },
  {
    designator: 'SCT',
    meaning: 'Eye region',
    value: '371398005',
  },
  {
    designator: 'SCT',
    meaning: 'Nose',
    value: '45206002',
  },
  {
    designator: 'SCT',
    meaning: 'Ear',
    value: '117590005',
  },
  {
    designator: 'SCT',
    meaning: 'Mouth',
    value: '123851003',
  },
  {
    designator: 'SCT',
    meaning: 'Back',
    value: '77568009',
  },
  {
    designator: 'SCT',
    meaning: 'Buttock',
    value: '46862004',
  },
  {
    designator: 'SCT',
    meaning: 'Face',
    value: '89545001',
  },
  {
    designator: 'SCT',
    meaning: 'Lumbar region',
    value: '52612000',
  },
  {
    designator: 'SCT',
    meaning: 'Penis',
    value: '18911002',
  },
  {
    designator: 'SCT',
    meaning: 'Right inguinal region',
    value: '37117007',
  },
  {
    designator: 'SCT',
    meaning: 'Left inguinal region',
    value: '85119005',
  },
  {
    designator: 'SCT',
    meaning: 'Left lower quadrant of abdomen',
    value: '68505006',
  },
  {
    designator: 'SCT',
    meaning: 'Left upper quadrant of abdomen',
    value: '86367003',
  },
  {
    designator: 'SCT',
    meaning: 'Thigh',
    value: '68367000',
  },
  {
    designator: 'SCT',
    meaning: 'Right lower quadrant of abdomen',
    value: '48544008',
  },
  {
    designator: 'SCT',
    meaning: 'Right upper quadrant of abdomen',
    value: '50519007',
  },
  {
    designator: 'SCT',
    meaning: 'Vulva',
    value: '45292006',
  },
  {
    designator: 'SCT',
    meaning: 'Shoulder',
    value: '16982005',
  },
  {
    designator: 'SCT',
    meaning: 'Abdomen',
    value: '818981001',
  },
  {
    designator: 'SCT',
    meaning: 'Ankle joint',
    value: '70258002',
  },
  {
    designator: 'SCT',
    meaning: 'Breast',
    value: '70258002',
  },
  {
    designator: 'SCT',
    meaning: 'Chest',
    value: '816094009',
  },
  {
    designator: 'SCT',
    meaning: 'Elbow joint',
    value: '16953009',
  },
  {
    designator: 'SCT',
    meaning: 'Eye',
    value: '81745001',
  },
  {
    designator: 'SCT',
    meaning: 'Finger',
    value: '7569003',
  },
  {
    designator: 'SCT',
    meaning: 'Foot',
    value: '56459004',
  },
  {
    designator: 'SCT',
    meaning: 'Forearm',
    value: '14975008',
  },
  {
    designator: 'SCT',
    meaning: 'Hand',
    value: '85562004',
  },
  {
    designator: 'SCT',
    meaning: 'Knee',
    value: '72696002',
  },
  {
    designator: 'SCT',
    meaning: 'Lower leg',
    value: '30021000',
  },
  {
    designator: 'SCT',
    meaning: 'Neck',
    value: '45048000',
  },
  {
    designator: 'SCT',
    meaning: 'Toe',
    value: '29707007',
  },
  {
    designator: 'SCT',
    meaning: 'Upper arm',
    value: '40983000',
  },
  {
    designator: 'SCT',
    meaning: 'Wrist joint',
    value: '74670003',
  },
];

export const IMAGE_WIDTH = 2362;
export const IMAGE_HEIGHT = 3543;

export const DEFAULT_PART_WIDTH = 100;
export const DEFAULT_PART_HEIGHT = 100;

export interface Position {
  left: number;
  top: number;
  width?: number;
  height?: number;
  zIndex?: number;
}
export const positionMap: Record<string, Position | Position[]> = {
  Head: {
    left: 380,
    top: 70,
    width: 300,
  },
  'Eye region': {
    left: 380,
    top: 130,
    width: 300,
  },
  Nose: {
    left: 490,
    top: 180,
    zIndex: 1,
  },
  Ear: [
    {
      left: 340,
      top: 200,
      zIndex: 1,
    },
    {
      left: 640,
      top: 200,
      zIndex: 1,
    },
    {
      left: 1700,
      top: 200,
      zIndex: 1,
    },
    {
      left: 2000,
      top: 200,
      zIndex: 1,
    },
  ],
  Mouth: {
    left: 490,
    top: 270,
    zIndex: 1,
  },
  Back: {
    left: 1670,
    top: 800,
    width: 450,
    height: 200,
  },
  Buttock: {
    left: 1670,
    top: 1400,
    width: 450,
    height: 200,
  },
  Face: {
    left: 380,
    top: 110,
    width: 300,
    height: 300,
  },
  'Lumbar region': {
    left: 1670,
    top: 1050,
    width: 450,
    height: 200,
  },
  Penis: {
    left: 490,
    top: 1600,
  },
  'Right inguinal region': {
    left: 450,
    top: 1600,
  },
  'Left inguinal region': {
    left: 530,
    top: 1600,
  },
  'Left lower quadrant of abdomen': {
    left: 600,
    top: 1300,
    zIndex: 1,
  },
  'Left upper quadrant of abdomen': {
    left: 600,
    top: 1050,
    zIndex: 1,
  },
  'Right lower quadrant of abdomen': {
    left: 380,
    top: 1300,
    zIndex: 1,
  },
  'Right upper quadrant of abdomen': {
    left: 380,
    top: 1050,
    zIndex: 1,
  },
  Thigh: [
    {
      left: 240,
      top: 1700,
      width: 300,
      height: 300,
    },
    {
      left: 550,
      top: 1700,
      width: 300,
      height: 300,
    },
    {
      left: 1580,
      top: 1700,
      width: 300,
      height: 300,
    },
    {
      left: 1910,
      top: 1700,
      width: 300,
      height: 300,
    },
  ],
  Vulva: {
    left: 490,
    top: 1600,
  },
  Shoulder: [
    {
      left: 290,
      top: 500,
    },
    {
      left: 660,
      top: 500,
    },
    {
      left: 1650,
      top: 500,
    },
    {
      left: 2060,
      top: 500,
    },
  ],
  Abdomen: {
    left: 320,
    top: 1100,
    width: 450,
    height: 300,
  },
  Breast: {
    left: 640,
    top: 800,
    zIndex: 1,
  },
  Chest: {
    left: 320,
    top: 750,
    width: 450,
    height: 200,
  },
  'Elbow joint': [
    {
      left: 1470,
      top: 1130,
    },
    {
      left: 2210,
      top: 1130,
    },
  ],
  Eye: [
    {
      left: 430,
      top: 150,
      zIndex: 1,
    },
    {
      left: 550,
      top: 150,
      zIndex: 1,
    },
  ],
  Finger: [
    {
      left: 150,
      top: 1880,
    },
    {
      left: 840,
      top: 1880,
    },
    {
      left: 1500,
      top: 1880,
    },
    {
      left: 2180,
      top: 1880,
    },
  ],
  Foot: [
    {
      left: 360,
      top: 3340,
    },
    {
      left: 630,
      top: 3340,
    },
    {
      left: 1700,
      top: 3340,
    },
    {
      left: 2000,
      top: 3340,
    },
  ],
  Forearm: [
    {
      left: 80,
      top: 1430,
    },
    {
      left: 900,
      top: 1430,
    },
    {
      left: 1430,
      top: 1430,
    },
    {
      left: 2250,
      top: 1430,
    },
  ],
  Hand: [
    {
      left: 100,
      top: 1760,
    },
    {
      left: 910,
      top: 1760,
    },
    {
      left: 1450,
      top: 1760,
    },
    {
      left: 2230,
      top: 1760,
    },
  ],
  Knee: {
    left: 320,
    top: 2300,
    width: 450,
  },
  'Lower leg': [
    {
      left: 350,
      top: 2780,
    },
    {
      left: 640,
      top: 2780,
    },
    {
      left: 1690,
      top: 2780,
    },
    {
      left: 2010,
      top: 2780,
    },
  ],
  Neck: {
    left: 490,
    top: 420,
  },
  Toe: [
    {
      left: 350,
      top: 3400,
    },
    {
      left: 640,
      top: 3400,
    },
  ],
  'Upper arm': [
    {
      left: 140,
      top: 960,
    },
    {
      left: 850,
      top: 960,
    },
    {
      left: 1500,
      top: 960,
    },
    {
      left: 2200,
      top: 960,
    },
  ],
  'Ankle joint': [
    {
      left: 360,
      top: 3150,
    },
    {
      left: 630,
      top: 3150,
    },
    {
      left: 1710,
      top: 3150,
    },
    {
      left: 1990,
      top: 3150,
    },
  ],
  'Wrist joint': [
    {
      left: 60,
      top: 1600,
    },
    {
      left: 920,
      top: 1600,
    },
    {
      left: 1420,
      top: 1600,
    },
    {
      left: 2270,
      top: 1600,
    },
  ],
};
